{
  "title": "Личный профиль",
  "info": "Личные данные",
  "idCopy": "Скопировать ID",
  "copied": "ID скопирован",
  "copyFailed": "Не удалось скопировать ID",
  "name": "Имя",
  "surname": "Фамилия",
  "birth": "Дата рождения",
  "gender": "Пол",
  "chooseGender": "Выберите пол",
  "male": "Мужчина",
  "female": "Женщина",
  "save": "Сохранить",
  "saved": "Данные сохранены",
  "missing": "Заполните все личные данные.",
  "failed": "Не удалось сохранить данные.",
  "alreadySaved": "Личные данные подтверждены и заблокированы.",
  "confirmTitle": "Подтвердите действие",
  "confirmText": "Подтвердите правильность своих данных. После подтверждения изменить их можно только с разрешения администратора.",
  "verify": "Подтвердить",
  "back": "Назад",
  "contacts": "Контактные данные",
  "linked": "Подключено",
  "notLinked": "Не подключено",
  "unverified": "Не подтверждено",
  "manage": "Управлять",
  "telegram": "Telegram",
  "unavailable": "Недоступно",
  "phone": "Телефон",
  "email": "Эл. почта",
  "change": "Изменить данные",
  "pending": "Заявка рассматривается.",
  "requestTitle": "Изменение личных данных",
  "changeHelp": "Изменение требует одобрения администратора.",
  "reason": "Причина изменения",
  "submit": "Отправить запрос",
  "noChanges": "Изменений нет.",
  "changeFailed": "Не удалось отправить запрос.",
  "changeSent": "Запрос отправлен администратору.",
  "support": "Связаться с поддержкой",
  "age": "Укажите правильную дату рождения.",
  "loggingOut": "Выход...",
  "logout": "Выйти из аккаунта"
}
